import { render } from "./intro.vue?vue&type=template&id=4e12b7b4"
import script from "./intro.vue?vue&type=script&lang=js"
export * from "./intro.vue?vue&type=script&lang=js"

import "./intro.vue?vue&type=style&index=0&id=4e12b7b4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__